'use strict';
var BASWebServices;
(function (BASWebServices) {
    var MessageBoxCountFilter = (function () {
        function MessageBoxCountFilter() {
        }
        MessageBoxCountFilter.Factory = function () {
            return function (input, maxEntries) {
                if (input.length < maxEntries) {
                    return input;
                }
                else {
                    return input.slice(input.length - maxEntries, input.length - 1);
                }
            };
        };
        return MessageBoxCountFilter;
    }());
    BASWebServices.MessageBoxCountFilter = MessageBoxCountFilter;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=MessageBoxCountFilter.js.map